
export class PhoneNumber {

    constructor() { }

    PhoneID: string;
    JurisID: number;
    RefID: string;
    RefType?: number;

    PhoneType: string;
    PhoneNbr: string;
    Extension: string;
    OrderNo?: number;
    Carrier: string;
    IsRcvTxt?: number;
    IsActive?: number;
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/phonenumber.model.ts